import { Card, CardContent, CardHeader } from "@/shared/ui/card";
import { Skeleton } from "@/shared/ui/skeleton";

export const ConsoleDashboardSkeleton = () => {
  return (
    <>
      <div className="flex items-center justify-between mb-8">
        <div className="flex-1">
          <Skeleton className="h-9 w-64 mb-2" />
          <Skeleton className="h-5 w-full max-w-96" />
        </div>
        <Skeleton className="h-10 w-10 rounded-full" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {[1, 2, 3, 4].map((i) => (
          <Card key={i} className="bg-card border-border p-6">
            <div className="flex items-start justify-between mb-4">
              <Skeleton className="h-10 w-10 rounded-lg" />
            </div>
            <Skeleton className="h-8 w-24 mb-1" />
            <Skeleton className="h-4 w-32 mb-2" />
            <Skeleton className="h-3 w-40" />
          </Card>
        ))}
      </div>

      <div className="grid grid-cols-1 gap-6">
        <Card className="bg-card border-border p-6">
          <CardHeader>
            <Skeleton className="h-6 w-32" />
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="pb-4 border-b border-border">
                <Skeleton className="h-3 w-24 mb-1" />
                <Skeleton className="h-5 w-48 mb-1" />
                <Skeleton className="h-3 w-32" />
              </div>
              <div className="pb-4 border-b border-border">
                <Skeleton className="h-3 w-20 mb-1" />
                <Skeleton className="h-5 w-40 mb-1" />
                <Skeleton className="h-3 w-28" />
              </div>
              <div>
                <Skeleton className="h-3 w-20 mb-1" />
                <Skeleton className="h-6 w-16 rounded-full" />
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className="bg-card border-border p-6">
          <CardHeader>
            <Skeleton className="h-6 w-40" />
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="pb-4 border-b border-border">
                <Skeleton className="h-3 w-16 mb-1" />
                <Skeleton className="h-6 w-24 rounded-full" />
              </div>
              <div className="pb-4 border-b border-border">
                <Skeleton className="h-3 w-20 mb-1" />
                <Skeleton className="h-4 w-64" />
              </div>
              <div>
                <Skeleton className="h-3 w-24 mb-1" />
                <Skeleton className="h-3 w-full" />
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};

